import { COUNTRY_CODES } from "../../constants/countries";

export const MODELS_BY_COUNTRY = {
    [COUNTRY_CODES.ECUADOR]: {
        hide: [],   // Para ocultar modelos del objeto base
        include: [] // Para agregar objetos únicos por pais
    },
    [COUNTRY_CODES.PARAGUAY]: {
        include: [
            { key: 'distritos', name: 'Distritos', icon: '🗺️' },
            { key: 'departamentos', name: 'Departamentos', icon: '🏛️' },
            { key: 'ciudades', name: 'Ciudades', icon: '🌆' },
            { key: 'grupoPrecios', name: 'Grupo de precios', icon: '💰' },
        ],
        hide: []
    },
    [COUNTRY_CODES.HONDURAS]: {
        include: [
            { key: 'serieNCF', name: 'Series NCF', icon: '📄' },
        ],
        hide: []
    },
};